<template>
  <div class="modal-body-content">
    <div class="modal-body-list-box">
      <div class="search-box-in-title">
        <h2>{{ $t('authority') }} {{ $t('list') }}</h2>
        <div>
          <input v-model="search" :placeholder="$t('insert_search_query')" />
          <button type="button" @click.stop="showEditAuth()" class="action-button">{{ $t('create_new') }}</button>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th class="w30p" @click="toggleSort('auth', 'auth_name')">
              {{ $t('authority') }} {{ $t('name') }}
              <span v-if="sortStates.auth.find(col => col.id === 'auth_name').order">
                <img v-if="sortStates.auth.find(col => col.id === 'auth_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w20p" @click="toggleSort('auth', 'geofences')">
              {{ $t('geofence') }}
              <span v-if="sortStates.auth.find(col => col.id === 'geofences').order">
                <img v-if="sortStates.auth.find(col => col.id === 'geofences').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <!-- <th v-show="!getIsMobile()" class="w20p" @click="toggleSort('auth', 'groups')">
              {{ $t('group') }}
              <span v-if="sortStates.auth.find(col => col.id === 'groups').order">
                <img v-if="sortStates.auth.find(col => col.id === 'groups').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th> -->
            <th v-show="!getIsMobile()" class="w20p" @click="toggleSort('auth', 'devices')">
              {{ $t('device') }}
              <span v-if="sortStates.auth.find(col => col.id === 'devices').order">
                <img v-if="sortStates.auth.find(col => col.id === 'devices').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <!-- <th v-show="!getIsMobile()" class="w10p" style="cursor: not-allowed;">{{ $t('state') }}</th> -->
            <th class="w10p" style="cursor: not-allowed;">{{ $t('manage') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="auth in paginatedData" :key="auth.auth_id" :style="auth.is_deleted ? { background: '#EBEBEB' } : {}">
            <td :title="auth.auth_name" class="w30p" @click.stop="showEditAuth(auth)" style="text-align: left; padding-left: 10px;">
              {{ auth.auth_name }}
            </td>
            <td v-show="!getIsMobile()" :title="showGFName(auth.geofences, true)" class="w20p" @click.stop="showEditAuth(auth)" style="text-align: left; padding-left: 10px;">
              {{ showGFName(auth.geofences) }}
            </td>
            <!-- <td v-show="!getIsMobile()" :title="showGroupName(auth.groups, true)" class="w20p" @click.stop="showEditAuth(auth)" style="text-align: left; padding-left: 10px;">
              {{ showGroupName(auth.groups) }}
            </td> -->
            <td v-show="!getIsMobile()" :title="showDeviceName(auth.devices, true)" class="w20p" @click.stop="showEditAuth(auth)" style="text-align: left; padding-left: 10px;">
              {{ showDeviceName(auth.devices) }}
            </td>
            <!-- <td v-show="!getIsMobile()" class="w10p">
              <img :src="isActImage(auth.is_activated)" />
            </td> -->
            <td class="w10p" v-if="!auth.is_deleted">
              <img @click.stop="showEditAuth(auth)" src="@/assets/images/edit.svg" :title="'수정'"/>
              <img @click.stop="deleteAuth(auth.auth_id)" src="@/assets/images/delete.svg" :title="'삭제'"/>
            </td>
            <td class="w10p" v-else>
              <img @click.stop="restoreAuth(auth.auth_id)" src="@/assets/images/restore.svg" :title="'복원'"/>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 페이지네이션 -->
      <div class="pagination-control">
        <div>
          <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
          <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
        </div>
        <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
        <div>
          <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
        </div>
      </div>
    </div>

    <AuthorityEditModal v-if="isAuthEditModalOpen" />
  </div>
</template>
  
<script setup>
import { ref, onMounted, computed, nextTick, onUnmounted, watch } from 'vue';
import { auth_list, device_list, geofence_list, GET_SERVER_REQUEST, group_list, SERVER_REQUEST } from '../utils/ServerConnect';
import { loadingStore } from '@/utils/LoadingStore';
import { sortedAuthList, sortStates, toggleSort } from '@/utils/SortUtility';
import { isAuthEditModalOpen, showEditAuth } from '@/utils/ModalUtility';
import { getIsMobile } from '@/utils/GlobalUtility';
import AuthorityEditModal from './AuthorityEditModal.vue';

onMounted(() => {
  nextTick(() => {
    searchAuthority();
  })
  loadingStore.hideLoading();
});
onUnmounted(() => {
  isAuthEditModalOpen.value = false;
})
  
  // 권한 조회
const searchAuthority = async () => {
  loadingStore.showLoading();
  auth_list.value = await GET_SERVER_REQUEST('auth');
  device_list.value = await GET_SERVER_REQUEST('device');
  group_list.value = await GET_SERVER_REQUEST('group');
  geofence_list.value = await GET_SERVER_REQUEST('geofence');

  loadingStore.hideLoading();
};

const deleteAuth = async (id) => {
  const totalData = {
    auth_id: id
  }
  const jsonData = JSON.stringify(totalData);
  await SERVER_REQUEST('auth', 'DELETE', jsonData);

  searchAuthority();
};

const restoreAuth = async (id) => {
  const totalData = {
    auth_id: id,
    undelete: true
  }
  const jsonData = JSON.stringify(totalData);

  await SERVER_REQUEST('auth', 'DELETE', jsonData);

  searchAuthority();
};

const currentPage = ref(1);
const itemsPerPage = ref(10);
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredList.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

const search = ref("");
const filteredList = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedAuthList.value.filter(auth =>
  String(auth.auth_id).includes(query) // ID로 검색
    || String(auth.auth_name).toLowerCase().includes(query) // 이름으로 검색
    || String(auth.geofences).toLowerCase().includes(query) // 영역으로 검색
    || String(auth.groups).toLowerCase().includes(query) // 그룹으로 검색
    || String(auth.devices).toLowerCase().includes(query) // 장치로 검색
  );
});

// 현재 보고있는 페이지를 전체 페이지수에 맞춰 자동으로 바꿔줌
watch(
  () => filteredList.value.length,
  () => {
    const newTotalPages = Math.ceil(filteredList.value.length / itemsPerPage.value);
    if (currentPage.value > newTotalPages) {
      currentPage.value = newTotalPages || 1; // 0일 때도 대비
    }
  }
);

const showGFName = (list, showAll = false) => {
  if (!list) return;
  if (showAll) return geofence_list.value?.filter(gf => list.includes(gf.geofence_id)).map(gf => gf.geofence_name);

  if (list.length > 1) return geofence_list.value?.find(gf => gf.geofence_id === list[0])?.geofence_name + ' 외 ' + (list.length - 1) + '개';
  else return geofence_list.value?.find(gf => gf.geofence_id === list[0])?.geofence_name;
};
// const showGroupName = (list, showAll = false) => {
//   if (!list) return;
//   if (showAll) return group_list.value?.filter(group => list.includes(group.group_id)).map(group => group.group_name);

//   if (list.length > 1) return group_list.value?.find(group => group.group_id === list[0])?.group_name + ' 외 ' + (list.length - 1) + '개';
//   else return group_list.value?.find(group => group.group_id === list[0])?.group_name;
// }
const showDeviceName = (list, showAll = false) => {
  if (!list) return;
  if (showAll) return list;

  if (list.length > 1) return list[0] + ' 외 ' + (list.length - 1) + '개';
  else return list[0];
}

// const isActImage = (is_activated) => {
//   if (is_activated === null) return new URL('../assets/images/lock.svg', import.meta.url).href;
//   if (is_activated === 0) return new URL('../assets/images/disactivatied.svg', import.meta.url).href;
//   if (is_activated === 1) return new URL('../assets/images/activatied.svg', import.meta.url).href;
//   return new URL('../assets/images/lock.svg', import.meta.url).href;
// };
</script>